var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { H as HEADER, g as gsapWithCSS, F as FOOTER, a as arrowScripts } from "./_arrow.js?var=20250416";
const breadcrumbHover = () => {
  const breadcrumb = document.querySelector(".breadcrumb");
  if(breadcrumb == null){
    return ;
  }
  class hoverLineClass {
    constructor(el) {
      __publicField(this, "isPlaying");
      __publicField(this, "isHover");
      __publicField(this, "el");
      __publicField(this, "line");
      this.isPlaying = false;
      this.isHover = false;
      this.el = el;
      const line = document.createElement("span");
      line.classList.add("js-linkBar");
      this.el.prepend(line);
      this.line = line;
      gsapWithCSS.set(this.el, {
        position: "relative"
      });
      gsapWithCSS.set(this.line, {
        transformOrigin: "left center",
        scaleX: 0,
        position: "absolute",
        bottom: "-1px",
        left: 0,
        width: "100%",
        height: "1px",
        display: "block",
        backgroundColor: "black"
      });
      this.el.addEventListener("mouseenter", () => {
        this._eRollOver();
      });
      this.el.addEventListener("mouseleave", () => {
        this._eRollOut();
      });
    }
    _eRollOver() {
      this.isHover = true;
      if (!this.isPlaying) {
        this._startRollOverMotion();
      }
    }
    _startRollOverMotion() {
      this.isPlaying = true;
      gsapWithCSS.to(this.line, {
        transformOrigin: "left center",
        scaleX: 1,
        duration: 0.48,
        ease: "power2.inOut",
        onComplete: () => {
          gsapWithCSS.set(this.line, {
            transformOrigin: "right center"
          });
          this._eCompleteRollOver();
        }
      });
    }
    _eCompleteRollOver() {
      this.isPlaying = false;
      if (!this.isHover) {
        this._eRollOut();
      }
    }
    _eRollOut() {
      this.isHover = false;
      if (!this.isPlaying) {
        this._startRollOutMotion();
      }
    }
    _startRollOutMotion() {
      this.isPlaying = true;
      gsapWithCSS.to(this.line, {
        scaleX: 0,
        duration: 0.32,
        onComplete: () => {
          gsapWithCSS.set(this.line, {
            transformOrigin: "left center"
          });
          this._eCompleteRollOut();
        }
      });
    }
    _eCompleteRollOut() {
      this.isPlaying = false;
      if (this.isHover) {
        this._eRollOver();
      }
    }
  }
  breadcrumb.querySelectorAll(".js-borderLink").forEach((el) => {
    new hoverLineClass(el);
  });
};
export {
  breadcrumbHover as b
};

document.addEventListener("DOMContentLoaded", () => {
  breadcrumbHover();
  FOOTER();
  arrowScripts();  
  HEADER();
});
